import HeroSection from './components/HeroSection';
import ProblemsSection from './components/ProblemsSection';
import DataSection from './components/DataSection';
import PriceComparisonSection from './components/PriceComparisonSection';
import FeaturesSection from './components/FeaturesSection';
import PricingSection from './components/PricingSection';
import ComparisonTable from './components/ComparisonTable';
import PortfolioSection from './components/PortfolioSection';
import ProcessSection from './components/ProcessSection';
import FAQSection from './components/FAQSection';
import NoteSection from './components/NoteSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-slate-50">
      <HeroSection />
      <ProblemsSection />
      <DataSection />
      <PriceComparisonSection />
      <FeaturesSection />
      <PricingSection />
      <ComparisonTable />
      <PortfolioSection />
      <ProcessSection />
      <FAQSection />
      <NoteSection />
      <CTASection />
      <Footer />
    </div>
  );
}
